import clsx from 'clsx';
import colorMapBotonBrillante from '../../../utils/colorMapBotonBrillante';
import styles from './BotonChico03.module.css';

const BotonChico03 = ({ texto, bgColor, funcion, disabled }) => {
  let colorElegido =
    colorMapBotonBrillante[bgColor] || colorMapBotonBrillante['blue'];

  return (
    <div className="bg-bgContenedorOscuro rounded-lg">
      <button
        className={clsx(
          styles[`${bgColor}-shine-background`],
          'text-gray-300 text-sm',
          'px-3 py-3 font-bold rounded-lg border-4 transition pixel-button w-fit',
          colorElegido.bg,
          colorElegido.border,
          disabled
            ? 'opacity-50 cursor-not-allowed'
            : [
                colorElegido.hoverBg,
                colorElegido.hoverBorder,
                colorElegido.hoverShadow,
                'hover:text-yellow-50',
              ]
        )}
        onClick={disabled ? undefined : funcion}
        disabled={disabled}
      >
        <span>{texto}</span>
      </button>
    </div>
  );
};

export default BotonChico03;
